import * as React from "react";
import { forwardRef } from "react";
const SvgFacebook = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", width: "36px", height: "36px", viewBox: "0 0 36 36", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("circle", { id: "Oval", fill: "#FFFFFF", cx: 18, cy: 18, r: 18 }), /* @__PURE__ */ React.createElement("path", { id: "f_1_", fill: "currentColor", d: "M19.2,26v-7.3h2.4l0.4-2.8h-2.7V14c0-0.8,0.2-1.4,1.4-1.4l1.4,0v-2.5c-0.3,0-1.1-0.1-2.1-0.1 c-2.1,0-3.5,1.3-3.5,3.8v2.1H14v2.8h2.4V26H19.2z" }));
const ForwardRef = forwardRef(SvgFacebook);
export { ForwardRef as ReactComponent };
